export default __webpack_public_path__ + "static/media/css3.3ec32022.svg";